import { useRef } from "react";
import PropTypes from "prop-types";

const useComponentWillMount = (fn) => {
  const willMount = useRef(true);

  if (willMount.current && fn && typeof fn === "function") {
    fn();
  }

  willMount.current = false;
};

useComponentWillMount.propTypes = {
  fn: PropTypes.func.isRequired,
};

export default useComponentWillMount;
